(function () {
  window.CartPage = window.CartPage || new function () {
    //runs once per page load
  var self = this;
  var cartQuantityUpdatePending = true;
  var cartQuantityUpdateRevision = 0;

  function markCartQuantityUpdatePending() {
    cartQuantityUpdatePending = true;
    cartQuantityUpdateRevision += 1;
    updateB2BOrderCheckoutAvailability();
  }

  function getAvailabilityMessage(quantity) {
    if (quantity === 0) return "No items were available, so unavailable products were removed from your cart.";
    if (quantity === 1) return "Only 1 item could be kept in your cart due to availability.";
    return "Only [quantity] items could be kept in your cart due to availability.".replace('[quantity]', quantity);
  }

  function getMinimumQuantityMessage(quantity) {
    return "This item requires a minimum order quantity of [quantity].".replace('[quantity]', quantity);
  }

  function getCartQuantityMessage(message) {
    if (message && message.type === 'minimum') return getMinimumQuantityMessage(message.quantity);
    return getAvailabilityMessage(message && typeof message === 'object' ? message.quantity : message);
  }

  function getInventoryMinimumRemovedMessage(items) {
    var itemList = items.map(function (item) {
      return item.sku ? item.title + ' (' + item.sku + ')' : item.title;
    }).join(', ');
    var messageTemplate = items.length === 1
      ? "[item_list] was removed from your cart because there was not enough inventory to meet the minimum order quantity."
      : "[item_list] were removed from your cart because there was not enough inventory to meet the minimum order quantity.";
    return messageTemplate.replace('[item_list]', itemList);
  }

  function getCartItemDetails(items) {
    var seenKeys = {};
    var details = [];
    items.forEach(function (itemEl) {
      var key = itemEl.dataset.key;
      if (!key || seenKeys[key] || !itemEl.querySelector('.quantity-box input[data-variant-id]')) return;
      seenKeys[key] = true;
      details.push({
        title: itemEl.dataset.productTitle || itemEl.querySelector('.title')?.textContent.trim() || 'Item',
        sku: itemEl.dataset.variantSku || ''
      });
    });
    return details;
  }

  function isB2BOrderAcknowledgementPending() {
    var condition = document.getElementById('b2bOrderCheckoutCondition');
    var checkbox = document.getElementById('b2b-order-checkout-conditions-checkbox');
    return Boolean(condition && !condition.classList.contains('hide') && checkbox && !checkbox.checked);
  }

  function updateB2BOrderCheckoutAvailability() {
    var checkoutButton = document.querySelector('#cart .loop-checkout-button');
    if (!checkoutButton) return;

    var acknowledgementPending = isB2BOrderAcknowledgementPending();
    var otherAcknowledgementPending = document.querySelector(
      '#preorderCheckoutCondition input:not(:checked), #personalizeCheckoutCondition input:not(:checked)'
    );
    var b2bPersonalizedItems = checkoutButton.dataset.b2bPersonalized === 'true' &&
      document.querySelector('#cart .cart-items .group-bundle--personalize');
    var checkoutBlockedByOrderTotal = checkoutButton.dataset.b2bBlocked === 'true';
    var additionalCheckoutButtons = document.querySelector('#cart .additional-checkout-buttons');
    checkoutButton.dataset.cartValidationPending = String(cartQuantityUpdatePending);

    var checkoutBlocked = cartQuantityUpdatePending || acknowledgementPending ||
      otherAcknowledgementPending || b2bPersonalizedItems || checkoutBlockedByOrderTotal;

    if (checkoutBlocked) {
      checkoutButton.setAttribute('disabled', 'disabled');
    } else {
      checkoutButton.removeAttribute('disabled');
    }

    if (additionalCheckoutButtons) {
      additionalCheckoutButtons.hidden = checkoutBlocked;
    }
  }

  self.updateB2BOrderCheckoutAvailability = updateB2BOrderCheckoutAvailability;

  function showB2BOrderCheckoutCondition() {
    if (!window.__b2bCartItemsRemoved) return;
    var condition = document.getElementById('b2bOrderCheckoutCondition');
    var checkbox = document.getElementById('b2b-order-checkout-conditions-checkbox');
    if (!condition || !checkbox) return;

    condition.classList.remove('hide');
    checkbox.checked = Boolean(window.__b2bCartOrderAcknowledged);
    if (checkbox.dataset.b2bCheckoutListenerAdded !== 'true') {
      checkbox.addEventListener('change', function () {
        window.__b2bCartOrderAcknowledged = checkbox.checked;
        updateB2BOrderCheckoutAvailability();
      });
      checkbox.dataset.b2bCheckoutListenerAdded = 'true';
    }
    updateB2BOrderCheckoutAvailability();
  }

  self.showB2BOrderCheckoutCondition = showB2BOrderCheckoutCondition;

  function getMinimumQuantityFromError(response) {
    if (!response || Number(response.status) !== 422) return null;
    var details = response.description || response.message || response.errors || response;
    var message = typeof details === 'string' ? details : JSON.stringify(details);
    var match = message.match(/\bminimum(?:\s+order)?(?:\s+quantity)?(?:\s+(?:of|is))?\s+(\d+)/i);
    return match ? parseInt(match[1], 10) : null;
  }

  function handleMinimumQuantityError(response, updates) {
    var errorMinimum = getMinimumQuantityFromError(response);
    if (!errorMinimum) return false;

    var messages = {};
    var updatedKeys = Object.keys(updates || {});
    document.querySelectorAll('#cart .cart-items .item').forEach(function (itemEl) {
      if (updatedKeys.indexOf(itemEl.dataset.key) === -1) return;
      var input = itemEl.querySelector('.quantity-box input[data-variant-id]');
      if (!input) return;

      var requestedQuantity = parseInt(updates[itemEl.dataset.key], 10) || 0;
      var itemMinimum = parseInt(input.dataset.min || '1', 10) || 1;
      var minimum = Math.max(errorMinimum, itemMinimum);
      if (updatedKeys.length > 1 && requestedQuantity >= minimum) return;
      messages[input.dataset.variantId] = { type: 'minimum', quantity: minimum };
    });

    if (!Object.keys(messages).length) {
      messages._minimum = { type: 'minimum', quantity: errorMinimum };
    }
    self.pendingAvailabilityMessages = messages;
    self.updateCart();
    return true;
  }

  self.renderCartAvailabilityMessages = function () {
    var messages = self.pendingAvailabilityMessages || {};
    var inventoryMinimumItems = self.pendingInventoryMinimumItems || [];
    self.pendingAvailabilityMessages = null;
    self.pendingInventoryMinimumItems = null;
    var cartContainer = document.querySelector('#cart');
    if (!cartContainer) return;

    var inventoryMinimumAlert = cartContainer.querySelector('#cart-inventory-minimum-alert');
    if (inventoryMinimumItems.length) {
      window.__b2bCartItemsRemoved = true;
      window.__b2bCartOrderAcknowledged = false;
      if (inventoryMinimumAlert) {
        inventoryMinimumAlert.textContent = getInventoryMinimumRemovedMessage(inventoryMinimumItems);
        inventoryMinimumAlert.classList.remove('hide');
      }
    }
    showB2BOrderCheckoutCondition();

    var renderedVariants = {};
    cartContainer.querySelectorAll('.cart-items .item').forEach(function (itemEl) {
      var input = itemEl.querySelector('.quantity-box input[data-variant-id]');
      var availability = itemEl.querySelector('.cart-item__availability');
      if (!input || !availability) return;

      var variantId = input.dataset.variantId;
      if (messages[variantId] === undefined || renderedVariants[variantId]) return;

      availability.textContent = getCartQuantityMessage(messages[variantId]);
      availability.setAttribute('role', 'status');
      availability.setAttribute('aria-live', 'polite');
      availability.classList.remove('hide');
      renderedVariants[variantId] = true;
    });

    var fallbackContainer = cartContainer.querySelector('.items-column');
    if (!fallbackContainer) return;
    Object.keys(messages).forEach(function (variantId) {
      if (renderedVariants[variantId]) return;
      var availability = document.createElement('div');
      availability.className = 'cart-item__availability cart-item__availability--cart';
      availability.textContent = getCartQuantityMessage(messages[variantId]);
      availability.setAttribute('role', 'status');
      availability.setAttribute('aria-live', 'polite');
      fallbackContainer.insertBefore(availability, fallbackContainer.firstChild);
    });
  };

  self.renderCartQuantityMaxMessages = function () {
    var flags = self.pendingMaxMessages || {};
    var cartContainer = document.querySelector('#cart');

    if (!cartContainer) return;
    cartContainer.querySelectorAll('.quantity-box input[data-variant-id]').forEach(function (input) {
      var flag = flags[input.dataset.variantId];
      if (!flag) return;

      var inputComponent = input.closest('quantity-input');
      if (!inputComponent) return;
      if (flag === 'min' && inputComponent.showMin) inputComponent.showMin();
      else if (flag === 'max' && inputComponent.showMax) inputComponent.showMax();
      else if (flag && flag.type === 'step' && inputComponent.showStep) inputComponent.showStep(parseInt(input.value, 10), flag.step);
    });
  };

  self.updateCart = function () {
    var refreshRevision = cartQuantityUpdateRevision;
    $s.showLoadingOverlay();
    $s.getJson({
      url: '/?sections=cart_content', success: async function (data) {
        var section = document.querySelector('.cart-content');
        $s.updateDynamicContent(section, data['cart_content']);
        var summaryWrapper = document.querySelector('#cart .summary-column');
        if (summaryWrapper) {
          const cartIsEmpty = data['cart_content'].indexOf('items-empty') !== -1;
          summaryWrapper.style.display = cartIsEmpty ? 'none' : '';
        }
        await $s.globalEval(data['cart_content']);
        // $s.hideLoadingOverlay();
        self.renderCartAvailabilityMessages();
        self.renderCartQuantityMaxMessages();


        if(! document.querySelector('.cart-items .is-preorder-item') && ! document.querySelector('.cart-items .group-bundle--personalize')) {
          document.getElementById('checkoutCondition')?.remove();
          const checkoutBtn = document.querySelector('.loop-checkout-button');
          // Only re-enable if no B2B-specific blocks are still active
          if (checkoutBtn && !checkoutBtn.dataset.b2bBlocked && checkoutBtn.dataset.b2bWindowRequired !== 'true' && checkoutBtn.dataset.b2bMixedWindows !== 'true') {
            checkoutBtn.removeAttribute('disabled');
          }
        } else if(! document.querySelector('.cart-items .group-bundle--personalize')) {
          document.getElementById('personalizeCheckoutCondition')?.remove();
        } else if(! document.querySelector('.cart-items .is-preorder-item')) {
          document.getElementById('preorderCheckoutCondition')?.remove();
        }
          if (cartQuantityUpdateRevision === refreshRevision) {
          cartQuantityUpdatePending = false;
        }
        self.updateB2BOrderCheckoutAvailability();
        $s.hideLoadingOverlay();
      }
    });
  }

  self.updateItemsQuantity = function (items, quantity, availabilityMessages, inventoryMinimumItems) {
    var data = { updates: {} }
    items.forEach(function (item) {
      data.updates[item.dataset.key] = quantity;
    });
    postUpdate(data, availabilityMessages, inventoryMinimumItems);
  }

  function postUpdate(data, availabilityMessages, inventoryMinimumItems) {
    if (!Object.keys(data.updates || {}).length) return;
    $s.showLoadingOverlay();
    $s.post({
      type: 'json',
      url: '/cart/update.js',
      data: data,
      success: async function (cart) {
        if (availabilityMessages && Object.keys(availabilityMessages).length) {
          self.pendingAvailabilityMessages = availabilityMessages;
        }

        if (inventoryMinimumItems && inventoryMinimumItems.length) {
          self.pendingInventoryMinimumItems = getCartItemDetails(inventoryMinimumItems);
        }

        if (!cart.item_count) {
          try { sessionStorage.removeItem('b2b_sel_state'); } catch (e) {}
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        }

        self.updateCart();
        window._sbCartPageUpdate = true;
        window.upcartRefreshCart?.();
      },
      error: function (response) {
        if (handleMinimumQuantityError(response, data.updates)) return;
        var failureMessage = response.description || response.message || response.errors || response;
        if (typeof failureMessage !== 'string') failureMessage = JSON.stringify(failureMessage);
        $s.addToCartFail(failureMessage);
        self.updateCart();
      }
    });
  }

  self.enforceCartQuantityLimits = async function (container) {
    var updates = {};
    var remainingByVariant = {};
    var quantityByVariant = {};
    var inventoryAdjustedVariants = {};
    var minimumAdjustedVariants = {};
    var inventoryMinimumRemovedItems = [];
    var cartItems = container.querySelectorAll('.cart-items .item');

    var i = 0;
    while (i !== cartItems.length) {
      var itemEl = cartItems[i];
      i++;
      var input = itemEl.querySelector('.quantity-box input[type="number"][data-variant-id]');
      if (!input) continue;

      var max = input.dataset.max ? parseInt(input.dataset.max, 10) : null;
      var current = parseInt(input.value, 10);
      var variantId = input.dataset.variantId;
      var hasInventoryLimit = input.dataset.availableQuantity !== undefined;
      var remaining = null;
      var step = parseInt(input.dataset.step || '1', 10);
      var min = parseInt(input.dataset.min || '1', 10);
      if ((max !== null && !Number.isFinite(max)) || !Number.isFinite(current) || !Number.isFinite(min) || !Number.isFinite(step) || step < 1) continue;

      if (hasInventoryLimit) {
        if (remainingByVariant[variantId] === undefined) {
          remainingByVariant[variantId] = Math.max(0, parseInt(input.dataset.availableQuantity, 10) || 0);
        }
        remaining = remainingByVariant[variantId];
        max = max === null ? remaining : Math.min(max, remaining);
      }

      var targetQty = current;
      var quantityAfterLimit = current;
      var removedForInsufficientInventory = false;
      if (current > 0) {
        if (max !== null && max < min) {
          targetQty = 0;
          quantityAfterLimit = 0;
          removedForInsufficientInventory = hasInventoryLimit && remaining < min;
        } else if (current < min) {
          targetQty = min;
          quantityAfterLimit = min;
          minimumAdjustedVariants[variantId] = min;
        } else if (max !== null && current > max) {
          targetQty = cartMaximumQuantity(max, min, step);
          quantityAfterLimit = targetQty;
          if (hasInventoryLimit && current > remaining) inventoryAdjustedVariants[variantId] = true;
        }
      }

      if (current !== targetQty) {
        markCartQuantityUpdatePending();
        input.value = targetQty;
        var relatedItems = $s.getItemsToUpdate
          ? await $s.getItemsToUpdate(itemEl, targetQty)
          : [itemEl];
        relatedItems.forEach(function (relatedItem) {
          updates[relatedItem.dataset.key] = targetQty;
        });
        if (removedForInsufficientInventory) {
          inventoryMinimumRemovedItems = inventoryMinimumRemovedItems.concat(relatedItems);
        }
      }

      if (hasInventoryLimit) {
        remainingByVariant[variantId] = Math.max(0, remaining - quantityAfterLimit);
        quantityByVariant[variantId] = (quantityByVariant[variantId] || 0) + quantityAfterLimit;
      }
    }

    var availabilityMessages = {};
    Object.keys(inventoryAdjustedVariants).forEach(function (variantId) {
      availabilityMessages[variantId] = quantityByVariant[variantId] || 0;
    });
    Object.keys(minimumAdjustedVariants).forEach(function (variantId) {
      if (availabilityMessages[variantId] === undefined) {
        availabilityMessages[variantId] = { type: 'minimum', quantity: minimumAdjustedVariants[variantId] };
      }
    });

    if (Object.keys(updates).length) {
      postUpdate({ updates: updates }, availabilityMessages, inventoryMinimumRemovedItems);
    } else {
      cartQuantityUpdatePending = false;
      updateB2BOrderCheckoutAvailability();
    }
  };
};

  //runs every time #cart div is replaced
  var cart = document.getElementById('cart');
  var itemsCount = 0;

  function cartFormatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, Shopify.money_format || '$');
    }
    var amount = (cents / 100).toFixed(2);
    return '$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function cartMaximumQuantity(max, min, step) {
    if (!Number.isFinite(max) || !Number.isFinite(min) || !Number.isFinite(step) || min > max) return 0;
    return min + Math.floor((max - min) / step) * step;
  }

  function cartVolumePriceAt(itemEl, qty) {
    var meta = itemEl.querySelector('.cart-price-breaks');
    if (!meta) return null;
    try {
      var data = JSON.parse(meta.textContent);
      var price = data.base;
      for (var i = 0; i < data.breaks.length; i++) {
        if (qty >= data.breaks[i].qty) price = data.breaks[i].price;
      }
      return price;
    } catch(e) { return null; }
  }

  function getCartInventoryLimit(input) {
    var variantId = input.dataset.variantId;
    var availableQuantity = parseInt(input.dataset.availableQuantity, 10);
    if (!variantId || !Number.isFinite(availableQuantity)) return null;

    var otherQuantity = 0;
    var currentItem = input.closest('.item');
    cart.querySelectorAll('.cart-items .item').forEach(function (item) {
      if (item === currentItem) return;
      var otherInput = item.querySelector('.quantity-box input[type="number"][data-variant-id]');
      if (otherInput && otherInput.dataset.variantId === variantId) {
        otherQuantity += Math.max(0, parseInt(otherInput.value, 10) || 0);
      }
    });

    return {
      maxForLine: Math.max(0, availableQuantity - otherQuantity),
      otherQuantity: otherQuantity
    };
  }

  cart.querySelectorAll('.cart-items .quantity-box input[type=number]').forEach(function (item) {
    itemsCount += item.value / 1;
  });

  var cartCountElement = document.querySelector('header .cart-count');
  if (cartCountElement) {
    cartCountElement.innerHTML = itemsCount > 0 ?  itemsCount : '';
  }

  var cartCountElementCart = document.querySelector('#cart .cart-count');
  if (cartCountElementCart) {
    cartCountElementCart.innerHTML = itemsCount > 0 ? "(" + itemsCount + ")" : '';
  }

  var cartCountElement2 = document.querySelector('.totalprods .cart-count');
  if (cartCountElement2) {
    cartCountElement2.innerHTML = itemsCount > 0 ? "(" + itemsCount + ")" : '';
  }

  cart.querySelectorAll('.remove').forEach(function (item) {
    item.addEventListener('click', async function (e) {
      e.preventDefault();
      var items = $s.getItemsToUpdate ? await $s.getItemsToUpdate(this.closest('.item'), 0) : [this.closest('.item')];
      CartPage.updateItemsQuantity(items, 0);
    });
  });

  cart.querySelectorAll('.cart-items input[type=number]').forEach(function (input) {
    input.addEventListener('input', function () {
      this.dataset.lastTyped = this.value;
    });

    input.addEventListener('change', async function (e) {
      var requestedQuantity = parseInt(this.value) || 0;
      var inventoryLimit = getCartInventoryLimit(this);
      var exceedsInventory = inventoryLimit && requestedQuantity > inventoryLimit.maxForLine;
      var val = requestedQuantity;
      var min = parseInt(this.dataset.min || '1');
      var max = this.dataset.max ? parseInt(this.dataset.max) : null;
      var step = parseInt(this.dataset.step || '1');

      if (inventoryLimit) {
        max = max === null ? inventoryLimit.maxForLine : Math.min(max, inventoryLimit.maxForLine);
      }

      CartPage.pendingMaxMessages = CartPage.pendingMaxMessages || {};
      var typedQuantity = parseInt(this.dataset.lastTyped, 10);
      delete this.dataset.lastTyped;
      if (!Number.isFinite(typedQuantity)) typedQuantity = requestedQuantity;
      if (max !== null && typedQuantity > max) {
        CartPage.pendingMaxMessages[this.dataset.variantId] = 'max';
      } else if (typedQuantity > 0 && typedQuantity < min) {
        CartPage.pendingMaxMessages[this.dataset.variantId] = 'min';
      } else if (step > 1 && typedQuantity > 0 && (typedQuantity - min) % step !== 0) {
        CartPage.pendingMaxMessages[this.dataset.variantId] = { type: 'step', step: step };
      } else {
        delete CartPage.pendingMaxMessages[this.dataset.variantId];
      }

      if (val !== 0) {
        if (max !== null && min > max) {
          val = 0;
        } else {
          if (val < min) val = min;
          if (step > 1) val = min + Math.round((val - min) / step) * step;
          if (max !== null && val > max) val = cartMaximumQuantity(max, min, step);
        }
      }
      if (parseInt(this.value) !== val) this.value = val;

      var itemEl = this.closest('.item');
      if (itemEl && val > 0) {
        var unitPrice = cartVolumePriceAt(itemEl, val);
        if (unitPrice !== null) {
          var linePriceEl = itemEl.querySelector('.price .final');
          if (linePriceEl) {
            linePriceEl.textContent = cartFormatMoney(unitPrice * val).replace('.00', '');
          }
        }
      }

      var items = $s.getItemsToUpdate ? await $s.getItemsToUpdate(itemEl, val) : [itemEl];
      var availabilityMessages = null;
      if (Number.isFinite(val) && exceedsInventory && val > 0) {
        availabilityMessages = {};
        availabilityMessages[this.dataset.variantId] = inventoryLimit.otherQuantity + val;
      } else if (Number.isFinite(val) && requestedQuantity > 0 && requestedQuantity < min && val > 0) {
        availabilityMessages = {};
        availabilityMessages[this.dataset.variantId] = { type: 'minimum', quantity: min };
      }
      var inventoryMinimumItems = inventoryLimit && requestedQuantity > 0 && min > inventoryLimit.maxForLine ? items : null;
      CartPage.updateItemsQuantity(items, val, availabilityMessages, inventoryMinimumItems);
    });
  });

  CartPage.enforceCartQuantityLimits(cart);
  CartPage.showB2BOrderCheckoutCondition();
  CartPage.updateB2BOrderCheckoutAvailability();

  cart.querySelectorAll('#cartAddons .cart-addons__product').forEach(function (item) {
    var btn = item.querySelector('.btn.add');
    if (!btn) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var id = btn.dataset.id;
      if (!id || btn.disabled) return;
      btn.disabled = true;
      $s.showLoadingOverlay();
      $s.post({
        url: '/cart/add.js',
        data: (function() {
          var props = { '_added_through_site': 'true' };
          var b2bWin = btn.dataset.b2bWindow;
          if (b2bWin !== undefined) {
            props['_order_type'] = (b2bWin && b2bWin !== 'immediate') ? 'future' : 'immediate';
          } else if (document.documentElement.getAttribute('data-buyer') === 'b2b') {
            props['_order_type'] = 'immediate';
          }
          return { 'id': id, 'quantity': 1, properties: props };
        })(),
        success: function () {
          btn.disabled = false;
          CartPage.updateCart();
          window._sbCartPageUpdate = true;
          window.upcartRefreshCart?.();
        },
        error: function (response) {
          btn.disabled = false;
          $s.addToCartFail(response.description);
        }
      });
    });
  });

  
    var checkNote = document.getElementById('checkbox-cart-note');
    if (checkNote) {
      var checkNoteChange = function () {
        var note = document.getElementById('cart-note');

        if (checkNote.checked) {
          note.style.display = 'block';
        } else {
          note.style.display = 'none';
          var textarea = note.querySelector('textarea');

          if (textarea.value != '') {
            textarea.value = '';
            $s.dispatchEvent(textarea, 'change');
          }
        }
      }

      var cartNoteLabel = checkNote.labels[0];
      if (cartNoteLabel) {
        cartNoteLabel.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            checkNote.click();
          }
        });
      }

      checkNote.addEventListener('click', checkNoteChange);
      checkNoteChange();
    }
  

  

  if ($s.validateBundlesInHTML) {
    $s.validateBundlesInHTML(document.querySelectorAll('#cart .item'));
  }
})();
